module.exports = "<svg class=\"spinner\" width=\"65px\" height=\"65px\" viewBox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\">\r\n  <circle class=\"path\" fill=\"none\" stroke-width=\"6\" stroke-linecap=\"round\" cx=\"33\" cy=\"33\" r=\"30\"></circle>\r\n</svg>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/Thomas/Projekte/palettes/src/app/shared/components/loading-spinner/loading-spinner.component.html
// module id = ../../../../../src/app/shared/components/loading-spinner/loading-spinner.component.html
// module chunks = main